// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ph-6";
export var imgContainer = "_ph-3";
export var menuIcon = "_ph-5";
export var pillWrapper = "_ph-2";
export var pillsContainer = "_ph-1";
export var subscriptionCard = "_ph-0";
export var subscriptionLogo = "_ph-4";